/**
 * User.js
 *
 * A user who can log in to this application.
 */
export default {

  tableName: 'colaboradores',

  datastore: 'app',

  display: ['name', 'lastName'],

  attributes: {

    createdBy: false,

    createdAt: false,

    updatedAt: false,

    userId: {
      type: 'number',
      allowNull: true,
      columnName: 'usuario_id'
    },

    name: {
      type: 'string',
      required: true,
      columnName: 'nombre'
    },

    lastName: {
      type: 'string',
      allowNull: true,
      columnName: 'paterno'
    },

    email: {
      type: 'string',
      allowNull: true
    },

    picture: {
      type: 'string',
      allowNull: true,
      columnName: 'foto'
    },

    active: {
      type: 'boolean',
      defaultsTo: false
    },

    profile: {
      collection: 'profile',
      via: 'user'
    },

  },


}



// WEBPACK FOOTER //
// ./src/models/User.js